import { Box, CircularProgress } from "@mui/material";
import { useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import authService from "../Auth/AuthService";
import CertificateStatusCard from "../reciept/CertificateStatusCard";

const CertificateVerifyPage = () => {
    const { code } = useParams();
    const [loading, setLoading] = useState(true);
    const [certificate, setCertificate] = useState(null);
    const [error, setError] = useState(null);
    const hasFetched = useRef(false);

    useEffect(() => {
        if (hasFetched.current) return;
        hasFetched.current = true;
        verifyCertificate();
    }, [code]);

    const verifyCertificate = async () => {

        setLoading(true);
        axios.get(authService.pathUrl("GET", `/certificate/verify/${code}`))
            .then((res) => {
                if (!res.data) {
                    throw new Error("Empty response");
                }
                setCertificate(res.data);
            }).catch(() => setError("Certificate not found or invalid"))
            .finally(() => setLoading(false))
    };

    return (
        <Box
            minHeight="100vh"
            display="flex"
            alignItems="center"
            justifyContent="center"
            bgcolor="#f5f5f5"
            p={2} >
            {loading && <CircularProgress />}

            {!loading && error && (
                <CertificateStatusCard
                    status="INVALID"
                    message={error}
                />
            )}

            {!loading && certificate && (
                <CertificateStatusCard
                    status="VALID"
                    data={certificate}
                />
            )}
        </Box>
    );
};

export default CertificateVerifyPage;
